import { Component, DestroyRef, inject, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
    selector: "mrdm-self-service-frontend-base",
    template: "",
    styleUrls: [],
    standalone: false
})
export class BaseComponent implements OnDestroy {
    protected _destroyRef = inject(DestroyRef);

    protected _destroyed$ = new Subject<void>();

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
